import { ReactElement } from 'react';
import { S_ClipLoader } from './S_ClipLoader';

export const S_TableClipLoader = (): ReactElement => (
  <div className='s-table-clip-loader'>
    <S_ClipLoader />
  </div>
);
